<nz-card [nzLoading]="loading">
  <div class="header-row">
    <h1>{{ campaignId ? ('ADMIN.EMAIL_CAMPAIGNS.EDIT_TITLE' | translate) : ('ADMIN.EMAIL_CAMPAIGNS.NEW_TITLE' | translate) }}</h1>
    <button nz-button nzType="default" routerLink="/admin/email-campaigns">{{ 'COMMON.BACK' | translate }}</button>
  </div>

  <form [formGroup]="form" class="editor-form">
    <div class="grid">
      <label>{{ 'ADMIN.EMAIL_CAMPAIGNS.NAME' | translate }}</label>
      <input nz-input formControlName="name" />

      <label>{{ 'ADMIN.EMAIL_CAMPAIGNS.TEMPLATE' | translate }}</label>
      <nz-select formControlName="templateId" [nzAllowClear]="true" [nzPlaceHolder]="'ADMIN.EMAIL_CAMPAIGNS.TEMPLATE_PLACEHOLDER' | translate">
        <nz-option *ngFor="let t of templates" [nzValue]="t._id" [nzLabel]="t.name"></nz-option>
      </nz-select>

      <label>{{ 'ADMIN.EMAIL_CAMPAIGNS.SUBJECT' | translate }}</label>
      <input nz-input formControlName="subject" />

      <label>{{ 'ADMIN.EMAIL_CAMPAIGNS.PREHEADER' | translate }}</label>
      <input nz-input formControlName="preheader" />

      <label>{{ 'ADMIN.EMAIL_CAMPAIGNS.SENDER_NAME' | translate }}</label>
      <input nz-input formControlName="senderName" />

      <label>{{ 'ADMIN.EMAIL_CAMPAIGNS.SENDER_EMAIL' | translate }}</label>
      <input nz-input formControlName="senderEmail" />

      <label>{{ 'ADMIN.EMAIL_CAMPAIGNS.REPLY_TO' | translate }}</label>
      <input nz-input formControlName="replyTo" />
    </div>

    <div class="block-toolbar">
      <nz-select class="block-type-select" formControlName="addBlockType">
        <nz-option *ngFor="let t of blockTypes" [nzValue]="t" [nzLabel]="blockTypeLabel(t)"></nz-option>
      </nz-select>
      <button nz-button nzType="default" type="button" (click)="addBlockFromToolbar()">{{ 'ADMIN.EMAIL_CAMPAIGNS.ADD_BLOCK' | translate }}</button>
      <span class="help-text">{{ 'ADMIN.EMAIL_CAMPAIGNS.BLOCK_ORDER_HELP' | translate }}</span>
    </div>

    <div formArrayName="blocks" class="blocks">
      <div class="block" *ngFor="let block of blocks.controls; let i = index" [formGroupName]="i">
        <div class="block-head">
          <div class="block-head-left">
            <span class="block-order">#{{ i + 1 }}</span>
            <nz-select class="block-type-select" formControlName="type">
              <nz-option *ngFor="let t of blockTypes" [nzValue]="t" [nzLabel]="blockTypeLabel(t)"></nz-option>
            </nz-select>
          </div>
          <div class="block-actions">
            <button nz-button nzType="default" type="button" (click)="moveBlockUp(i)">{{ 'ADMIN.EMAIL_CAMPAIGNS.MOVE_UP' | translate }}</button>
            <button nz-button nzType="default" type="button" (click)="moveBlockDown(i)">{{ 'ADMIN.EMAIL_CAMPAIGNS.MOVE_DOWN' | translate }}</button>
            <button nz-button nzType="text" nzDanger type="button" (click)="removeBlock(i)">{{ 'COMMON.DELETE' | translate }}</button>
          </div>
        </div>

        <ng-container [ngSwitch]="block.get('type')?.value">
          <div *ngSwitchCase="'hero'" class="block-fields">
            <input nz-input [value]="blockContent(i)['title'] || ''" (input)="updateBlockContent(i, 'title', $any($event.target).value)" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.FIELD_TITLE' | translate" />
            <input nz-input [value]="blockContent(i)['subtitle'] || ''" (input)="updateBlockContent(i, 'subtitle', $any($event.target).value)" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.FIELD_SUBTITLE' | translate" />
            <textarea nz-input rows="3" [value]="blockContent(i)['body'] || ''" (input)="updateBlockContent(i, 'body', $any($event.target).value)" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.FIELD_BODY' | translate"></textarea>
          </div>

          <div *ngSwitchCase="'text'" class="block-fields">
            <input nz-input [value]="blockContent(i)['title'] || ''" (input)="updateBlockContent(i, 'title', $any($event.target).value)" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.FIELD_TITLE' | translate" />
            <textarea nz-input rows="4" [value]="blockContent(i)['body'] || ''" (input)="updateBlockContent(i, 'body', $any($event.target).value)" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.FIELD_BODY' | translate"></textarea>
          </div>

          <div *ngSwitchCase="'image'" class="block-fields image-block-fields">
            <div class="image-block-header">{{ 'ADMIN.EMAIL_CAMPAIGNS.IMAGE_BLOCK_HELP' | translate }}</div>
            <input nz-input [value]="blockContent(i)['url'] || ''" (input)="updateBlockContent(i, 'url', $any($event.target).value)" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.FIELD_IMAGE_URL' | translate" />
            <input nz-input [value]="blockContent(i)['alt'] || ''" (input)="updateBlockContent(i, 'alt', $any($event.target).value)" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.FIELD_ALT' | translate" />
            <input nz-input [value]="blockContent(i)['caption'] || ''" (input)="updateBlockContent(i, 'caption', $any($event.target).value)" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.FIELD_CAPTION' | translate" />
            <nz-upload [nzBeforeUpload]="uploadImageForBlock.bind(this, i)" [nzShowUploadList]="false">
              <button nz-button nzType="default" type="button">{{ 'ADMIN.EMAIL_CAMPAIGNS.UPLOAD_IMAGE_FOR_BLOCK' | translate }}</button>
            </nz-upload>
          </div>

          <div *ngSwitchCase="'feature_list'" class="block-fields">
            <input nz-input [value]="blockContent(i)['title'] || ''" (input)="updateBlockContent(i, 'title', $any($event.target).value)" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.FIELD_TITLE' | translate" />
            <textarea nz-input rows="4" [value]="blockContent(i)['items']?.join('\n') || ''" (input)="updateBlockContent(i, 'items', linesToItems($any($event.target).value))" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.FIELD_LIST_ITEMS' | translate"></textarea>
          </div>

          <div *ngSwitchCase="'cta'" class="block-fields">
            <input nz-input [value]="blockContent(i)['text'] || ''" (input)="updateBlockContent(i, 'text', $any($event.target).value)" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.FIELD_CTA_TEXT' | translate" />
            <input nz-input [value]="blockContent(i)['href'] || ''" (input)="updateBlockContent(i, 'href', $any($event.target).value)" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.FIELD_CTA_URL' | translate" />
          </div>

          <div *ngSwitchCase="'footer_note'" class="block-fields">
            <textarea nz-input rows="3" [value]="blockContent(i)['note'] || ''" (input)="updateBlockContent(i, 'note', $any($event.target).value)" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.FIELD_FOOTER_NOTE' | translate"></textarea>
          </div>

          <div *ngSwitchDefault class="block-fields">
            <p>{{ 'ADMIN.EMAIL_CAMPAIGNS.NO_FIELDS_FOR_BLOCK' | translate }}</p>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="send-controls">
      <input nz-input [(ngModel)]="testEmail" [ngModelOptions]="{ standalone: true }" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.TEST_EMAIL_PLACEHOLDER' | translate" />
      <button nz-button nzType="default" type="button" (click)="sendTest()">{{ 'ADMIN.EMAIL_CAMPAIGNS.SEND_TEST' | translate }}</button>
      <span class="help-text">{{ 'ADMIN.EMAIL_CAMPAIGNS.TEST_SEND_HELP' | translate }}</span>
    </div>

    <div class="recipient-controls">
      <nz-select [(ngModel)]="recipientMode" [ngModelOptions]="{ standalone: true }">
        <nz-option nzValue="single" [nzLabel]="'ADMIN.EMAIL_CAMPAIGNS.RECIPIENT_SINGLE' | translate"></nz-option>
        <nz-option nzValue="paste" [nzLabel]="'ADMIN.EMAIL_CAMPAIGNS.RECIPIENT_PASTE' | translate"></nz-option>
        <nz-option nzValue="users" [nzLabel]="'ADMIN.EMAIL_CAMPAIGNS.RECIPIENT_USERS' | translate"></nz-option>
      </nz-select>

      <ng-container [ngSwitch]="recipientMode">
        <input *ngSwitchCase="'single'" nz-input [(ngModel)]="singleEmail" [ngModelOptions]="{ standalone: true }" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.RECIPIENT_SINGLE_PLACEHOLDER' | translate" />
        <textarea *ngSwitchCase="'paste'" nz-input rows="4" [(ngModel)]="pastedEmails" [ngModelOptions]="{ standalone: true }" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.RECIPIENT_PASTE_PLACEHOLDER' | translate"></textarea>
        <div *ngSwitchCase="'users'" class="users-picker">
          <input nz-input [(ngModel)]="userSearch" [ngModelOptions]="{ standalone: true }" (ngModelChange)="searchUsers()" [placeholder]="'ADMIN.EMAIL_CAMPAIGNS.USER_SEARCH_PLACEHOLDER' | translate" />
          <nz-select nzMode="multiple" [(ngModel)]="selectedUserIds" [ngModelOptions]="{ standalone: true }">
            <nz-option *ngFor="let user of users" [nzValue]="user.id" [nzLabel]="user.email + (user.displayName ? ' (' + user.displayName + ')' : '')"></nz-option>
          </nz-select>
        </div>
      </ng-container>
    </div>

    <div class="send-controls">
      <span class="help-text">{{ 'ADMIN.EMAIL_CAMPAIGNS.REAL_SEND_QUEUE_HELP' | translate }}</span>
      <span class="help-text" *ngIf="latestSendStatus">{{ 'ADMIN.EMAIL_CAMPAIGNS.LATEST_SEND_STATUS' | translate }}: {{ ('ADMIN.EMAIL_CAMPAIGNS.SEND_STATUSES.' + latestSendStatus.toUpperCase()) | translate }}</span>
      <span class="help-text" *ngIf="isLatestSendQueuedOrProcessing()">{{ 'ADMIN.EMAIL_CAMPAIGNS.QUEUED_DISPATCH_HINT' | translate }}</span>
    </div>

    <div class="actions">
      <button nz-button nzType="default" type="button" [nzLoading]="saving" (click)="saveDraft()">{{ 'ADMIN.EMAIL_CAMPAIGNS.SAVE_DRAFT' | translate }}</button>
      <button nz-button nzType="default" type="button" (click)="preview()">{{ 'ADMIN.EMAIL_CAMPAIGNS.PREVIEW' | translate }}</button>
      <button nz-button nzType="primary" type="button" (click)="sendNow()">{{ 'ADMIN.EMAIL_CAMPAIGNS.SEND_NOW' | translate }}</button>
    </div>
  </form>

  <nz-card *ngIf="previewHtml" class="preview-card">
    <h3>{{ 'ADMIN.EMAIL_CAMPAIGNS.PREVIEW' | translate }}</h3>
    <div class="preview-frame" [innerHTML]="previewHtml"></div>
  </nz-card>

  <nz-card *ngIf="campaignId" class="history-card">
    <h3>{{ 'ADMIN.EMAIL_CAMPAIGNS.SEND_HISTORY' | translate }}</h3>
    <nz-select [ngModel]="selectedSendId" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onSendSelected($event)" [nzPlaceHolder]="'ADMIN.EMAIL_CAMPAIGNS.SELECT_SEND' | translate" [nzAllowClear]="true">
      <nz-option
        *ngFor="let send of sends"
        [nzValue]="send._id"
        [nzLabel]="(send.kind || '') + ' � ' + (send.status || '') + ' � ' + (send.createdAt | date: 'short')"
      ></nz-option>
    </nz-select>

    <nz-table [nzData]="recipients" [nzLoading]="recipientsLoading" [nzPageSize]="10" *ngIf="selectedSendId">
      <thead>
        <tr>
          <th>{{ 'ADMIN.EMAIL_CAMPAIGNS.RECIPIENT' | translate }}</th>
          <th>{{ 'ADMIN.EMAIL_CAMPAIGNS.STATUS' | translate }}</th>
          <th>{{ 'ADMIN.EMAIL_CAMPAIGNS.SOURCE' | translate }}</th>
          <th>{{ 'ADMIN.EMAIL_CAMPAIGNS.ERROR' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of recipients">
          <td>{{ item.email }}</td>
          <td><nz-tag>{{ item.status }}</nz-tag></td>
          <td>{{ item.source }}</td>
          <td>{{ item.lastError || item.skipReason || '-' }}</td>
        </tr>
      </tbody>
    </nz-table>
  </nz-card>
</nz-card>




